<div class="accordion-content-container"
     [attr.data-padding]="padding"
     [attr.data-open]="isOpen">
  <div class="accordion-content-inner">
    <ng-content></ng-content>
  </div>
</div>